var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPageNavigationInProgress)?_c('div',{staticClass:"progress-bar"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }